import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteCompanyDockActions } from "store/ducks/settings/company-docks";

export function* deleteCompanyDockRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.delete,
      `/company-docks/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteCompanyDockActions.success(data));
    notify("success", "Doca deletada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteCompanyDockActions.failure(errorMessage));
  }
}
